import type { WrongQuestion } from '@/types'

export type WrongQuestionUpdate = Partial<Omit<WrongQuestion, 'id' | 'studentId' | 'createdAt'>>

export function projectWrongQuestionUpdates(
  wrongQuestions: readonly WrongQuestion[],
  ids: readonly string[],
  update: WrongQuestionUpdate,
): WrongQuestion[] {
  const targetIds = new Set(ids)
  if (targetIds.size === 0 || !wrongQuestions.some((question) => targetIds.has(question.id))) {
    return wrongQuestions as WrongQuestion[]
  }
  const normalizedUpdate = 'masteryState' in update
    ? { ...update, status: update.masteryState }
    : update
  return wrongQuestions.map((question) => (
    targetIds.has(question.id) ? { ...question, ...normalizedUpdate } : question
  ))
}
